/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CompanySpaceSetting } from './CompanySpaceSetting';
import {
    CompanySpaceSettingFromJSON,
    CompanySpaceSettingFromJSONTyped,
    CompanySpaceSettingToJSON,
} from './CompanySpaceSetting';
import type { UserShowResponseCompanySpacesInnerAvailableMarketplaces } from './UserShowResponseCompanySpacesInnerAvailableMarketplaces';
import {
    UserShowResponseCompanySpacesInnerAvailableMarketplacesFromJSON,
    UserShowResponseCompanySpacesInnerAvailableMarketplacesFromJSONTyped,
    UserShowResponseCompanySpacesInnerAvailableMarketplacesToJSON,
} from './UserShowResponseCompanySpacesInnerAvailableMarketplaces';
import type { UserShowResponseCompanySpacesInnerSalesPermissions } from './UserShowResponseCompanySpacesInnerSalesPermissions';
import {
    UserShowResponseCompanySpacesInnerSalesPermissionsFromJSON,
    UserShowResponseCompanySpacesInnerSalesPermissionsFromJSONTyped,
    UserShowResponseCompanySpacesInnerSalesPermissionsToJSON,
} from './UserShowResponseCompanySpacesInnerSalesPermissions';
import type { UserShowResponseCompanySpacesInnerSubscription } from './UserShowResponseCompanySpacesInnerSubscription';
import {
    UserShowResponseCompanySpacesInnerSubscriptionFromJSON,
    UserShowResponseCompanySpacesInnerSubscriptionFromJSONTyped,
    UserShowResponseCompanySpacesInnerSubscriptionToJSON,
} from './UserShowResponseCompanySpacesInnerSubscription';

/**
 * User in company space
 * @export
 * @interface UserShowResponseCompanySpacesInner
 */
export interface UserShowResponseCompanySpacesInner {
    /**
     * 
     * @type {number}
     * @memberof UserShowResponseCompanySpacesInner
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UserShowResponseCompanySpacesInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserShowResponseCompanySpacesInner
     */
    subdomain: string;
    /**
     * 
     * @type {string}
     * @memberof UserShowResponseCompanySpacesInner
     */
    custom_domain?: string;
    /**
     * 
     * @type {string}
     * @memberof UserShowResponseCompanySpacesInner
     */
    app_url: string;
    /**
     * 
     * @type {string}
     * @memberof UserShowResponseCompanySpacesInner
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof UserShowResponseCompanySpacesInner
     */
    user_role: string;
    /**
     * 
     * @type {string}
     * @memberof UserShowResponseCompanySpacesInner
     */
    image_url: string;
    /**
     * 
     * @type {string}
     * @memberof UserShowResponseCompanySpacesInner
     */
    small_image_url: string;
    /**
     * 
     * @type {string}
     * @memberof UserShowResponseCompanySpacesInner
     */
    language: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserShowResponseCompanySpacesInner
     */
    user_content_activation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserShowResponseCompanySpacesInner
     */
    user_content_creation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserShowResponseCompanySpacesInner
     */
    invitation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserShowResponseCompanySpacesInner
     */
    domain_check: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserShowResponseCompanySpacesInner
     */
    allowed_domains: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserShowResponseCompanySpacesInner
     */
    domain_hard_check: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserShowResponseCompanySpacesInner
     */
    email_check: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserShowResponseCompanySpacesInner
     */
    email_hard_check: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserShowResponseCompanySpacesInner
     */
    mandatory_params: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserShowResponseCompanySpacesInner
     */
    password_check: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserShowResponseCompanySpacesInner
     */
    client_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserShowResponseCompanySpacesInner
     */
    user_allowed_to_add_department: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserShowResponseCompanySpacesInner
     */
    enable_external_ids: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserShowResponseCompanySpacesInner
     */
    new_dashboard_on: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserShowResponseCompanySpacesInner
     */
    logo_picture_url: string;
    /**
     * 
     * @type {string}
     * @memberof UserShowResponseCompanySpacesInner
     */
    small_logo_picture_url: string;
    /**
     * 
     * @type {string}
     * @memberof UserShowResponseCompanySpacesInner
     */
    marketplace_url: string;
    /**
     * 
     * @type {UserShowResponseCompanySpacesInnerAvailableMarketplaces}
     * @memberof UserShowResponseCompanySpacesInner
     */
    available_marketplaces: UserShowResponseCompanySpacesInnerAvailableMarketplaces;
    /**
     * 
     * @type {boolean}
     * @memberof UserShowResponseCompanySpacesInner
     */
    supervisors: boolean;
    /**
     * 
     * @type {UserShowResponseCompanySpacesInnerSalesPermissions}
     * @memberof UserShowResponseCompanySpacesInner
     */
    sales_permissions: UserShowResponseCompanySpacesInnerSalesPermissions;
    /**
     * 
     * @type {boolean}
     * @memberof UserShowResponseCompanySpacesInner
     */
    auto_content_upgrade: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserShowResponseCompanySpacesInner
     */
    private_space: boolean;
    /**
     * 
     * @type {CompanySpaceSetting}
     * @memberof UserShowResponseCompanySpacesInner
     */
    space_settings?: CompanySpaceSetting;
    /**
     * 
     * @type {UserShowResponseCompanySpacesInnerSubscription}
     * @memberof UserShowResponseCompanySpacesInner
     */
    subscription?: UserShowResponseCompanySpacesInnerSubscription;
}

/**
 * Check if a given object implements the UserShowResponseCompanySpacesInner interface.
 */
export function instanceOfUserShowResponseCompanySpacesInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "subdomain" in value;
    isInstance = isInstance && "app_url" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "user_role" in value;
    isInstance = isInstance && "image_url" in value;
    isInstance = isInstance && "small_image_url" in value;
    isInstance = isInstance && "language" in value;
    isInstance = isInstance && "user_content_activation" in value;
    isInstance = isInstance && "user_content_creation" in value;
    isInstance = isInstance && "invitation" in value;
    isInstance = isInstance && "domain_check" in value;
    isInstance = isInstance && "allowed_domains" in value;
    isInstance = isInstance && "domain_hard_check" in value;
    isInstance = isInstance && "email_check" in value;
    isInstance = isInstance && "email_hard_check" in value;
    isInstance = isInstance && "mandatory_params" in value;
    isInstance = isInstance && "password_check" in value;
    isInstance = isInstance && "client_id" in value;
    isInstance = isInstance && "user_allowed_to_add_department" in value;
    isInstance = isInstance && "enable_external_ids" in value;
    isInstance = isInstance && "new_dashboard_on" in value;
    isInstance = isInstance && "logo_picture_url" in value;
    isInstance = isInstance && "small_logo_picture_url" in value;
    isInstance = isInstance && "marketplace_url" in value;
    isInstance = isInstance && "available_marketplaces" in value;
    isInstance = isInstance && "supervisors" in value;
    isInstance = isInstance && "sales_permissions" in value;
    isInstance = isInstance && "auto_content_upgrade" in value;
    isInstance = isInstance && "private_space" in value;

    return isInstance;
}

export function UserShowResponseCompanySpacesInnerFromJSON(json: any): UserShowResponseCompanySpacesInner {
    return UserShowResponseCompanySpacesInnerFromJSONTyped(json, false);
}

export function UserShowResponseCompanySpacesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserShowResponseCompanySpacesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'subdomain': json['subdomain'],
        'custom_domain': !exists(json, 'custom_domain') ? undefined : json['custom_domain'],
        'app_url': json['app_url'],
        'state': json['state'],
        'user_role': json['user_role'],
        'image_url': json['image_url'],
        'small_image_url': json['small_image_url'],
        'language': json['language'],
        'user_content_activation': json['user_content_activation'],
        'user_content_creation': json['user_content_creation'],
        'invitation': json['invitation'],
        'domain_check': json['domain_check'],
        'allowed_domains': json['allowed_domains'],
        'domain_hard_check': json['domain_hard_check'],
        'email_check': json['email_check'],
        'email_hard_check': json['email_hard_check'],
        'mandatory_params': json['mandatory_params'],
        'password_check': json['password_check'],
        'client_id': json['client_id'],
        'user_allowed_to_add_department': json['user_allowed_to_add_department'],
        'enable_external_ids': json['enable_external_ids'],
        'new_dashboard_on': json['new_dashboard_on'],
        'logo_picture_url': json['logo_picture_url'],
        'small_logo_picture_url': json['small_logo_picture_url'],
        'marketplace_url': json['marketplace_url'],
        'available_marketplaces': UserShowResponseCompanySpacesInnerAvailableMarketplacesFromJSON(json['available_marketplaces']),
        'supervisors': json['supervisors'],
        'sales_permissions': UserShowResponseCompanySpacesInnerSalesPermissionsFromJSON(json['sales_permissions']),
        'auto_content_upgrade': json['auto_content_upgrade'],
        'private_space': json['private_space'],
        'space_settings': !exists(json, 'space_settings') ? undefined : CompanySpaceSettingFromJSON(json['space_settings']),
        'subscription': !exists(json, 'subscription') ? undefined : UserShowResponseCompanySpacesInnerSubscriptionFromJSON(json['subscription']),
    };
}

export function UserShowResponseCompanySpacesInnerToJSON(value?: UserShowResponseCompanySpacesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'subdomain': value.subdomain,
        'custom_domain': value.custom_domain,
        'app_url': value.app_url,
        'state': value.state,
        'user_role': value.user_role,
        'image_url': value.image_url,
        'small_image_url': value.small_image_url,
        'language': value.language,
        'user_content_activation': value.user_content_activation,
        'user_content_creation': value.user_content_creation,
        'invitation': value.invitation,
        'domain_check': value.domain_check,
        'allowed_domains': value.allowed_domains,
        'domain_hard_check': value.domain_hard_check,
        'email_check': value.email_check,
        'email_hard_check': value.email_hard_check,
        'mandatory_params': value.mandatory_params,
        'password_check': value.password_check,
        'client_id': value.client_id,
        'user_allowed_to_add_department': value.user_allowed_to_add_department,
        'enable_external_ids': value.enable_external_ids,
        'new_dashboard_on': value.new_dashboard_on,
        'logo_picture_url': value.logo_picture_url,
        'small_logo_picture_url': value.small_logo_picture_url,
        'marketplace_url': value.marketplace_url,
        'available_marketplaces': UserShowResponseCompanySpacesInnerAvailableMarketplacesToJSON(value.available_marketplaces),
        'supervisors': value.supervisors,
        'sales_permissions': UserShowResponseCompanySpacesInnerSalesPermissionsToJSON(value.sales_permissions),
        'auto_content_upgrade': value.auto_content_upgrade,
        'private_space': value.private_space,
        'space_settings': CompanySpaceSettingToJSON(value.space_settings),
        'subscription': UserShowResponseCompanySpacesInnerSubscriptionToJSON(value.subscription),
    };
}

